module.exports = __webpack_public_path__ + "media/images/top-content-img-15-0f3f126f6361e7a8192afbe2edbf0c15.jpg";